/**
 * useApplication Hook
 *
 * React Query hook for fetching a single application by ID.
 */

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { applicationService } from '../../../api/application.service';
import type { ApplicationSanitized } from '../../../types/application.types';
import { getErrorMessage } from '../../../lib/utils/errors';

/**
 * Hook for fetching a single application
 */
export const useApplication = (
  tenantId: string,
  applicationId: string
): UseQueryResult<ApplicationSanitized, Error> => {
  return useQuery<ApplicationSanitized, Error>({
    queryKey: ['applications', tenantId, applicationId],
    queryFn: async () => {
      console.log('[useApplication] Fetching application:', applicationId);
      return await applicationService.getApplication(tenantId, applicationId);
    },
    enabled: !!tenantId && !!applicationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    onError: (error) => {
      console.error('[useApplication] Failed to fetch application:', getErrorMessage(error));
    },
  });
};
